// src/range.ts
var range = (length) => Array.from({ length }, (_, i) => i);

export {
  range
};
